import { createRoot } from "react-dom/client";
import { connectToFirebase } from "./modules/common/features/notifications/providers";
import { StrictMode } from "react";
import App from "./application/app";
import { connectSentry } from "@/application/sentry/connect-sentry";
import { connectStaleBuildReload } from "@/application/stale-build/connect-stale-build-reload";

connectToFirebase();
connectSentry();
connectStaleBuildReload();

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
